import Cookies from "js-cookie";
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoutesComponent = () => {
  const location = useLocation();
  const isAuthorized = Cookies.get("token");
  return isAuthorized ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoutesComponent;
